(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4743],{

/***/ 80760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(80760),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 31182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nQ": function() { return /* binding */ LocalizedResourcesLinks; },
/* harmony export */   "yt": function() { return /* binding */ LocalizedOurProductFooterLinksV2; }
/* harmony export */ });
/* unused harmony export getLocalizedLink */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72632);
/* harmony import */ var _constants_localization__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_localization__WEBPACK_IMPORTED_MODULE_0__);


var SPANISH_HELP_CENTER_LINK = "//support.monday.com/hc/es";
var FRENCH_HELP_CENTER_LINK = "//support.monday.com/hc/fr";
var PORTUGEESE_HELP_CENTER_LINK = "//support.monday.com/hc/es";
var GERMAN_HELP_CENTER_LINK = "//support.monday.com/hc/de";
var JAPANESE_HELP_CENTER_LINK = "//support.monday.com/hc/ja";
var SPANISH_BLOG_LINK = "//monday.com/blog/es/";
var PORTUGEESE_BLOG_LINK = "//monday.com/blog/pt/";
var FRENCH_BLOG_LINK = "//monday.com/blog/fr/";
var GERMAN_BLOG_LINK = "//monday.com/blog/de/";
var JAPANESE_BLOG_LINK = "//monday.com/blog/ja/";
var SPANISH_WORK_OS_LINK = "//monday.com/blog/es/work-os/";
var PORTUGEESE_WORK_OS_LINK = "//monday.com/blog/pt/work-os-uma-plataforma-para-o-futuro-do-trabalho/";
var FRENCH_WORK_OS_LINK = "//monday.com/blog/fr/le-work-os-lavenir-du-travail/";
var _obj;
var LocalizedResourcesLinks = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID, {
    "header.blog": {
        href: SPANISH_BLOG_LINK
    },
    "header.helpCenter": {
        href: SPANISH_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: SPANISH_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: SPANISH_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID, {
    "header.blog": {
        href: PORTUGEESE_BLOG_LINK
    },
    "header.helpCenter": {
        href: PORTUGEESE_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: PORTUGEESE_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: PORTUGEESE_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID, {
    "header.blog": {
        href: FRENCH_BLOG_LINK
    },
    "header.helpCenter": {
        href: FRENCH_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: FRENCH_BLOG_LINK,
        openInNewTab: true
    },
    "footer.helpCenter": {
        href: FRENCH_HELP_CENTER_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.GERMAN_LOCALE_ID, {
    "header.blog": {
        href: GERMAN_BLOG_LINK
    },
    "header.helpCenter": {
        href: GERMAN_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: GERMAN_BLOG_LINK,
        openInNewTab: true
    }
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.JAPANESE_LOCALE_ID, {
    "header.blog": {
        href: JAPANESE_BLOG_LINK
    },
    "header.helpCenter": {
        href: JAPANESE_HELP_CENTER_LINK
    },
    "footer.blog": {
        href: JAPANESE_BLOG_LINK,
        openInNewTab: true
    }
}), _obj);
var DEFAULT_LINKS = {
    "header.blog": {
        href: "//monday.com/blog"
    }
};
var _obj1;
var LocalizedOurProductFooterLinksV2 = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.SPANISH_LOCALE_ID, {
    "footer.workOS": SPANISH_WORK_OS_LINK
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.PORTUGEESE_LOCALE_ID, {
    "footer.workOS": PORTUGEESE_WORK_OS_LINK
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj1, _constants_localization__WEBPACK_IMPORTED_MODULE_0__.FRENCH_LOCALE_ID, {
    "footer.workOS": FRENCH_WORK_OS_LINK
}), _obj1);
var getLocalizedLink = function(link, localeId) {
    var _DEFAULT_LINKS_link;
    var localizedLinks = LocalizedResourcesLinks[localeId];
    return localizedLinks && localizedLinks[link] ? localizedLinks[link].href : ((_DEFAULT_LINKS_link = DEFAULT_LINKS[link]) === null || _DEFAULT_LINKS_link === void 0 ? void 0 : _DEFAULT_LINKS_link.href) || link;
};


/***/ })

}]);